<template>
    <div v-if="isError"></div>
    <div v-else class="weather-component" :title="`更新于${now.obsTime},${now.windDir}${now.windScale}级`">
        <i :class="`qi-${now.icon}`"></i>
        <span class="weather-text">{{ now.text }}</span>
        <span class="weather-temp">{{ now.temp }}℃</span>
        <span v-if="false">{{now.windDir}}{{now.windScale}}级</span>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                now:{
                    "obsTime": "2025-10-13T00:48+08:00",
                    "temp": "13",
                    "feelsLike": "11",
                    "icon": "305",
                    "text": "123456",
                    "wind360": "0",
                    "windDir": "北风",
                    "windScale": "3",
                    "windSpeed": "13",
                    "humidity": "100",
                    "precip": "0.0",
                    "pressure": "1013",
                    "vis": "7",
                    "cloud": "100",
                    "dew": "12"
                },
                isError:true,
            }
        },
        created(){
            this.$http.get('/api/licp/weather_now.json',{}).then(response=>{
                    return response.data;
                }).then(data => {
                    if(!data || !data.data || !data.data.now || typeof data.data.now !== 'object'){
                        throw '出错';
                    }
                    this.now = data.data.now;
                    this.isError = false;
                }).catch((response)=>{
                    console.log('无法获取天气');
                });
        }
    }
</script>

<style>
    .weather-component{
        height:100%;
        line-height:1;
        display:flex;
        justify-content: center;
        align-items:center;
        font-size:13px;
        color:#77accc;
        user-select: none;
    }
    .weather-text{
        padding-inline-start: 0.25em;
        padding-inline-end: 0.25em;
    }
    .weather-text{
        padding-inline-end: 0.25em;
    }
</style>


// WEBPACK FOOTER //
// src/components/Weather.vue